import { FikaPrintCardMenu } from './fika-print-card-menu';

export class FikaEdiblesCardMenu extends FikaPrintCardMenu {}
